import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import FontIcon from 'material-ui/FontIcon';
import CircularProgress from 'material-ui/CircularProgress';
import axios from 'axios';
import KeepAlive from '../KeepAlive';
import {Message} from "mgUiKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetLastLoginsComponent';

var styles = AppSettings.styles;

class LastLogins extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            errorMessage: "",
            data: [],
            showLoading: true,
            opened: false
        }
        this.getLastLogin = this.getLastLogin.bind(this);
    }

    getLastLogin(status) {
        if(this.state.opened){
            this.setState({
                error: false,
                errorMessage: "",
                data: [],
                showLoading: true,
                opened:false
            });
            return;
        }
        

        this.setState({
            showLoading: true,
            opened:true
        });

        var url = AppSettings['env'].urlUserBoxLastLogin;
        axios.get(url)
            .then(({data, status, statusText}) => {
                var showLoading = false;
                if (data.errors.length == 0) {
                    this.setState({
                        error: false,
                        errorMessage: "",
                        data: data.lastLogins,
                        showLoading: showLoading,
                        opened:true
                    });
                } else {
                    this.setState({
                        error: true,
                        errorMessage: <KeepAlive />,
                        data: [],
                        showLoading: showLoading,
                        opened:true

                    });
                }
            })

            .catch(function(error) {
                this.setState({
                    error: true,
                    errorMessage: "Si è verificato un problema",
                    data: [],
                    showLoading: false,
                    opened:true
                });
            });
    }

    renderLastLogins(){
        if(this.state.showLoading){
            return <CircularProgress style={styles.loadingIcon}/>;
        }

        if(this.state.error){
            return <Message align="center">{this.state.errorMessage}</Message>;
        }

        var lastLogins;
        if (this.state.data.length > 0) {
            lastLogins = this.state.data.map(function (login, i) {
                
                var key = "lastlogin" + i;
                var openLastLogin = (e) => {
                    this.context.openLinkPopup(e, login.url);
                }
                return (
                    <li key={key}>

                        <a title="Visualizza l'estratto conto relativo a questa sessione"
                        href={login.url}
                        onClick={openLastLogin}
                        className="mg-login-data"
                        style={{color: AppSettings.theme.primarycolor}}>
                            <FontIcon className="fa fa-clock-o" style={styles.iconClockLogin}/>
                            <strong>{login.date}</strong>
                        </a>
                        <span>{login.duration} / IP: {login.ipAddress}</span>
                    </li>

                )
            }.bind(this));
        }
        else {
            lastLogins = "";
        }

        return (
            <ul className="mg-user-data-profile">
                {lastLogins}
            </ul>
        );
    }

    render() {
        var title = <div style={styles.pointer} onClick={this.getLastLogin}>Ultimi Login</div>;
        //var subTitle  = <div style={styles.pointer} onClick={this.getLastLogin}>Dettagli</div>;

        return (
            <div id="mg-ultimi-login">
                <Card expanded={this.state.opened} onExpandChange={this.getLastLogin} containerStyle={styles.mgCardStyle}>
                    <CardHeader titleStyle={styles.mgCardTitle}
                                subtitleStyle={styles.mgCardSubTitle}
                                title={title}
                                //subtitle={subTitle}
                                subtitle="Ultimi accessi" 
                                actAsExpander={false}
                                showExpandableButton={true}
                    />
                    <CardText expandable={true} style={styles.cardText}>
                        {this.renderLastLogins()}
                    </CardText>
                </Card>
            </div>

        );
    }
}

LastLogins.displayName = componentName;

// PropTypes validation
LastLogins.propTypes = {
  
};
LastLogins.contextTypes = {
    openLinkPopup: PropTypes.func
}
// default props
LastLogins.defaultProps = {
  
};

export default LastLogins;